import Axios from 'axios';
import * as dashboardActions from './dashboardReducer';
import { toastr } from 'react-redux-toastr';
import handleErrorResponse from '../../../helpers/handleErrorResponse';

const clearData = () => {
  return {
    type: dashboardActions.CLEAR_DATA,
  };
};

const clearSearchResults = () => {
  return {
    type: dashboardActions.CLEAR_SEARCH_RESULTS,
  };
};

const fetchSearchResults = (query) => {
  return (dispatch) => {
    if (query.length < 1) {
      return dispatch({
        type: dashboardActions.SET_SEARCH_RESULTS,
        data: {
          meta: {
            policies: [],
            policy_applications: [],
          },
        },
      });
    }

    return Axios.get('search/quick?filter[query]=' + query)
      .then((response) => {
        dispatch({
          type: dashboardActions.SET_SEARCH_RESULTS,
          data: response.data,
        });
        return true;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error);
      });
  };
};

const isLoading = (status) => {
  return {
    type: dashboardActions.IS_LOADING,
    status,
  };
};

const fetchStats = () => {
  return (dispatch) => {
    return Axios.get('statistics/dashboard')
      .then((response) => {
        dispatch({
          type: dashboardActions.SET_STATS,
          data: response.data,
        });
        return true;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error);
      });
  };
};
//
// const fetchBrokerStats = (range = 'month') =>  {
//   return (dispatch) => {
//     return Axios.get('statistics/brokers/' + range)
//       .then((response) => {
//         dispatch({
//           type: dashboardActions.SET_BROKER_STATS,
//           data: response.data,
//         });
//         return true;
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//   };
// };

const fetchReminders = () => {
  return (dispatch) => {
    // let endpoint = 'notes?filter[share]=broker' + id + '&filter[reminders]=true';
    // const endpoint = 'notes?filter[user]=' +userId+ '&filter[reminders]=true';
    const endpoint = 'reminders';

    return Axios.get(endpoint)
      .then((response) => {
        dispatch({
          type: dashboardActions.SET_REMINDERS,
          data: response.data,
        });
        return true;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error);
      });
  };
};

const fetchAllReminders = () => {
  return (dispatch) => {
    let endpoint = 'notes?page[limit]=1000' + '&filter[reminders]=true';

    return Axios.get(endpoint)
      .then((response) => {
        dispatch(isLoading(true));
        dispatch({
          type: dashboardActions.SET_ALL_REMINDERS,
          data: response.data,
        });
        dispatch(isLoading(false));
        return true;
      })
      .catch((error) => {
        dispatch(isLoading(false));
        // eslint-disable-next-line no-console
        console.error(error);
      });
  };
};

const fetchAnnouncements = () => {
  return (dispatch) => {
    let endpoint = 'contents?filter[template.type]=announcement&filter[active]=true';

    return Axios.get(endpoint)
      .then((response) => {
        dispatch({
          type: dashboardActions.SET_ANNOUNCEMENTS,
          data: response.data.data,
          included: response.data.included,
        });
        return true;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error);
      });
  };
};

const clearSelectedReminders = (ids) => {
  return (dispatch) => {
    return Axios.get('reminders/clear/' + ids)
      .then(() => {
        dispatch(fetchReminders());
        toastr.success('Success', 'Selected reminders have been cleared');
        return true;
      })
      .catch((error) => {
        handleErrorResponse(error, 'There was an error clearing selected reminders');
        // eslint-disable-next-line no-console
        console.error(error);
      });
  };
};

const clearReminder = (id, doFetch = true) => {
  return (dispatch) => {
    return Axios.patch('notes/' + id, { data: { attributes: { reminder: null } } })
      .then((resp) => {
        if (doFetch) {
          dispatch(fetchReminders());
        }
        toastr.success('Success', 'The reminder has been cleared');
        return resp?.data;
      })
      .catch((error) => {
        handleErrorResponse(error, 'There was an error creating clearing the reminder');
        // eslint-disable-next-line no-console
        console.error(error);
      });
  };
};

export const actions = {
  clearData,
  clearSearchResults,
  fetchSearchResults,
  isLoading,
  fetchStats,
  // fetchBrokerStats,
  fetchReminders,
  fetchAllReminders,
  fetchAnnouncements,
  clearReminder,
  clearSelectedReminders,
};
